import { render, staticRenderFns } from "./laboral-references-confirm-token-invalid.vue?vue&type=template&id=2604787a&"
import script from "./laboral-references-confirm-token-invalid.vue?vue&type=script&lang=js&"
export * from "./laboral-references-confirm-token-invalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports